// app/javascript/controllers/player_report_controller.js
import { Controller } from "@hotwired/stimulus"
import { csrfHeaders } from "../lib/csrf"

// Corner badge -> bottom-sheet report modal. Mirrors report_modal_controller so
// it opens identically; submits FormData to /player_reports/.
export default class extends Controller {
  static targets = ["modal", "backdrop", "panel", "form", "error", "success", "actions", "submit"]

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.body.classList.add("modal-open")

    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("translate-y-full")
    })
  }

  close() {
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("translate-y-full")

    const panel = this.panelTarget
    panel.addEventListener("transitionend", () => {
      this.modalTarget.classList.add("hidden")
      document.body.style.overflow = ""
      document.body.classList.remove("modal-open")
      this.errorTarget.classList.add("hidden")
      this.successTarget.classList.add("hidden")
      this.actionsTarget.classList.remove("hidden")
      this.submitTarget.disabled = false
      this.formTarget.reset()
    }, { once: true })
  }

  async submit(event) {
    event.preventDefault()
    const form = this.formTarget
    const data = new FormData(form)
    data.set("url", window.location.href)

    this.submitTarget.disabled = true
    this.errorTarget.classList.add("hidden")

    try {
      const response = await fetch("/player_reports/", {
        method: "POST",
        headers: csrfHeaders(),
        body: data
      })

      if (response.ok) {
        this.actionsTarget.classList.add("hidden")
        this.successTarget.classList.remove("hidden")
        setTimeout(() => this.close(), 2500)
      } else {
        const json = await response.json().catch(() => ({}))
        this.errorTarget.textContent = json.error || "Something went wrong. Please try again."
        this.errorTarget.classList.remove("hidden")
        this.submitTarget.disabled = false
      }
    } catch {
      this.errorTarget.textContent = "Network error. Please try again."
      this.errorTarget.classList.remove("hidden")
      this.submitTarget.disabled = false
    }
  }
}
